import { executePost } from '@/api/AxiosUtil'

import axios from 'axios'

export const getPrintSpecs = (specs) => {
  const fileName = specs.split('.').slice(0, -1).join('.')
  const specsObj = '/api/v3/specs/PRINT_SPEC/' + fileName

  return new Promise((resolve, reject) => {
    axios
      .get(specsObj)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject())
  })
}

export const getProductSpecs = (file) => {
  return new Promise((resolve, reject) => {
    file = file.replace(/\.[^/.]+$/, '')
    axios
      .get('/api/v3/specs/PRODUCT_SPEC/' + file)
      .then((response) => {
        resolve(response.data)
        //        resolve(JSON.parse(response.data))
      })
      .catch((error) => reject())
  })
}

export const printTemplates = () => {
  return new Promise((resolve, reject) => {
    axios
      .get('/json/printtemplates.json.php')
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject())
  })
}

export const deletePrintTemplate = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/json/printtemplate-delete.json.php', id)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject())
  })
}

export const savePrintTemplate = (template) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/json/printtemplate-save.json.php', template)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject())
  })
}
